export enum ShipmentReceiverFleetResponseStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NoResponse = 'NO_RESPONSE',
}
